<template>
  <div class="client opportunity summary-editor">
    <v-btn icon @click="editing = !editing"> <v-icon>mdi-pencil</v-icon> </v-btn>
    <v-dialog scrollable v-model="editing" max-width="900px" width="66vw" height="50">
      <v-card>
        <v-card-title class="title">Edit About {{ opportunity.name }}</v-card-title>

        <v-divider />

        <v-card-text style="height: 50vh;">
          <v-form v-model="valid" @submit.prevent="submit" ref="form">
            <v-textarea box
              label="About"
              v-model="modifiedOpportunity.summary"
              :rules="rules.summary" required
              :error-messages="errors.summary || []"
              :color="themes.client.light.input"
              height="38vh"
            />

            <v-textarea box no-resize
              label="Brief Summary (SEO)"
              v-model="modifiedOpportunity.blurb"
              :rules="rules.blurb" required
              :error-messages="errors.blurb || []"
              :color="themes.client.light.input"
              counter="256"
              hint="This shows in search results on Leaply and internet search engines"
              rows="2"
            />
          </v-form>
        </v-card-text>

        <v-card-actions
          ><v-spacer />
          <v-btn flat @click="editing = false" :color="themes.client.light.cancel"> Cancel </v-btn>
          <v-btn
            :color="themes.client.light.primaryActionButton"
            :disabled="!valid"
            @click="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  props: { opportunity: Object },

  data() {
    return {
      editing: false,
      valid: false,
      rules: {
        summary: [v => !!v || 'must be specified'],
        blurb: [
          v => !!v || 'must be specified',
          v => !v || v.length < 256 || 'must be shorter than 256 characters',
        ],
      },
      errors: {},
      // Model
      modifiedOpportunity: JSON.parse(JSON.stringify(this.opportunity)),
    }
  },

  watch: {
    editing() {
      this.modifiedOpportunity = JSON.parse(JSON.stringify(this.opportunity))
      this.setBlurb()
    },
  },

  methods: {
    setBlurb() {
      if (!_.get(this.modifiedOpportunity, 'blurb.length') && this.modifiedOpportunity.summary) {
        this.modifiedOpportunity.blurb = this.modifiedOpportunity.summary.substring(0, 180)
      }
    },

    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('client/opportunities/update', this.modifiedOpportunity).then(errors => {
          if (errors) {
            this.errors = errors
            this.$store.dispatch('snackbarError', 'There was a problem saving the summary')
          } else {
            this.$store.dispatch('snackbarSuccess', 'The summary was saved successfully')
            this.editing = false
          }
        })
      }
    },
  },
}
</script>
